// Copyright (c) 2016 Deere & Company

import branches from './branches';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import factoryCodes from './factory-codes';
import formatting from './formatting';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import statuses from './statuses';
import views from './views';

export const getCombinedReducers = () =>
    combineReducers({
        branches,
        busyCounter,
        criteria,
        factoryCodes,
        formatting,
        report,
        reportIsScrollable,
        showNoResultsFound,
        statuses,
        views
    });



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/reducers/index.js